import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// columns: array
// sortColumn: object
// onSort: function

class MultiselectTableHeader extends Component {
  raiseSort = column => {
    const { disableAllSort, onSort } = this.props;

    if (!disableAllSort && column.isSortable) {
      const sortColumn = { ...this.props.sortColumn };
      if (sortColumn.path === column.path)
        sortColumn.order = sortColumn.order === "asc" ? "desc" : "asc";
      else {
        sortColumn.path = column.path;
        sortColumn.order = "asc";
      }
      onSort(sortColumn);
    }
  };

  renderSortIcon = column => {
    const { sortColumn, disableAllSort } = this.props;

    if (!disableAllSort && column.isSortable) {
      if (column.path !== sortColumn.path)
        return <FontAwesomeIcon icon="sort" className="fa-fw ml-2" />;
      if (sortColumn.order === "asc")
        return <FontAwesomeIcon icon="sort-up" className="fa-fw ml-2" />;
      return <FontAwesomeIcon icon="sort-down" className="fa-fw ml-2" />;
    }
    return "";
  };

  render() {
    const { columns } = this.props;
    const checkCol = (
      <th className="bg-lightgray" key={`multiselectTableKey_checkCol`}></th>
    );
    return (
      <thead>
        <tr>
          {[
            checkCol,
            ...columns.map(column => (
              <th
                className={column.thClassName + " pointer-cursor bg-lightgray"}
                key={`multiselectTableThKey_${column.path || column.key}`}
                onClick={() => this.raiseSort(column)}
              >
                {column.label}
                {this.renderSortIcon(column)}
              </th>
            ))
          ]}
        </tr>
      </thead>
    );
  }
}

export default MultiselectTableHeader;
